<project-navigation
  [headerTitle]="('projectNavigation.title_move_project' | translate) + ': ' + getItemName()"
  [headerText]="'projectNavigation.text_move_project'"
  [model]="model"
  [submitEnabled]="submitEnabled"
  [actionButtonLabel]="'global.label.move'"
  [visibleFeatures]="{
    compositeCheckBox: false,
    pinnedProjects: false,
    recentlyUsedProjects: false,
    history: true,
    projectActionsMenu: true,
    projectGroupContextMenu: false,
    newConfigurationGroupBtn: true,
    newFolderBtn: true,
    dialogSearch: true,
    tabs: true,
    breadcrumbs: true,
  }"
  [itemToMoveOrCopy]="itemToMove"
  (submitEnabledChanged)="updateSubmitEnabled()"
  (actionBtnClick)="moveProject()"
  (cancel)="cancel()"
></project-navigation>
